// extracted by mini-css-extract-plugin
export default {"wrapper":"kyrc2OrpgyRJ8kIGxK_o"};